import React from 'react';
import Navbar from '../components/Navbar';
import SeoHead from '../components/SeoHead';
import Footer from '../components/Footer';

const Cookies = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-900">
      <SeoHead
        title="Politique Cookies - PulseCIO"
        description="Découvrez la politique d'utilisation des cookies de PulseCIO, plateforme SaaS de centralisation des messages professionnels."
        breadcrumb={{ name: "Cookies", path: "/cookies" }}
      />
      <Navbar />
      <main className="flex-1 container mx-auto px-6 py-20">
        <h1 className="text-3xl font-bold mb-6 text-black dark:text-white">Politique Cookies</h1>
        <div className="prose dark:prose-invert max-w-none">
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Le site utilise uniquement les cookies strictement nécessaires au fonctionnement du service. 
            Aucune fonctionnalité de tracking marketing ou d'analytics tiers n'est activée par défaut.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Types de cookies utilisés
          </h2>
          
          <h3 className="text-lg font-semibold mt-4 mb-2 text-black dark:text-white">
            Cookies strictement nécessaires
          </h3>
          <p className="text-gray-700 dark:text-gray-300 mb-2">
            Ces cookies sont essentiels au fonctionnement du site et ne peuvent être désactivés :
          </p>
          <ul className="list-disc ml-6 mb-4 text-gray-700 dark:text-gray-300">
            <li><strong>Cookie de session :</strong> maintien de votre session utilisateur active</li>
            <li><strong>Token d'authentification :</strong> sécurisation de votre connexion (JWT)</li>
            <li><strong>Cookie CSRF :</strong> protection contre les attaques cross-site</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2 text-black dark:text-white">
            Stockage local (localStorage)
          </h3>
          <p className="text-gray-700 dark:text-gray-300 mb-2">
            Nous utilisons le stockage local de votre navigateur pour :
          </p>
          <ul className="list-disc ml-6 mb-4 text-gray-700 dark:text-gray-300">
            <li>Préférences d'affichage (langue, thème sombre/clair)</li>
            <li>Paramètres d'interface utilisateur</li>
            <li>Consentement aux cookies</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2 text-black dark:text-white">
            Absence de cookies tiers
          </h3>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Nous n'utilisons aucun cookie de suivi publicitaire ou analytique tiers (Google Analytics, 
            Facebook Pixel, etc.). Votre navigation reste privée et n'est pas suivie à des fins marketing.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Refuser ou supprimer les cookies
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Vous pouvez refuser les cookies en configurant votre navigateur. Notez que le refus des cookies 
            nécessaires empêchera l'utilisation correcte du service (ex : impossibilité de se connecter).
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Durée de conservation
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Les cookies de session sont supprimés à la fermeture du navigateur. Les préférences utilisateur 
            stockées en localStorage sont conservées jusqu'à leur suppression manuelle ou jusqu'à la suppression 
            du compte.
          </p>

          <p className="text-sm text-gray-500 dark:text-gray-400">
            Le site affiche une bannière d'information sur les cookies et enregistre votre choix dans le stockage local.
          </p>
        </div>
      </main>
      <div className="w-full flex justify-center mt-12 mb-2">
        <a href="/" className="inline-flex items-center px-5 py-2 rounded-lg bg-blue-600 text-white font-semibold shadow hover:bg-blue-700 transition">
          ← Retour à la page principale
        </a>
      </div>
      <Footer />
    </div>
  );
};

export default Cookies;